<template>
  <div>
    <van-nav-bar title="审批" />
    <van-row>
      <van-col :span="24">
        <base-select v-model="form.corp" label="主体" :options="dictList.filter(dict => dict.type === 2)" />
      </van-col>
    </van-row>
    <van-row>
      <van-col :span="24">
        <van-field v-model="form.itemName" label="审批事项" placeholder="请选择审批事项"
                   readonly @click="showApproveItem = true" />
      </van-col>
    </van-row>
    <van-row>
      <van-col :span="24">
        <base-select v-model="form.approve_type" label="审批类型" :disabled="disabled"
                     :options="CONST.APPROVE_TYPE" />
      </van-col>
    </van-row>
    <van-row>
      <van-col :span="24">
        <base-input-number v-model="form.approve_amount" label="费用金额" />
      </van-col>
    </van-row>
    <van-row v-if="form.approve_type === 2">
      <van-col :span="24">
        <base-date v-model="form.get_invoice_date" label="回票日期" />
      </van-col>
    </van-row>
    <van-row>
      <van-col :span="24">
        <base-textarea v-model="form.corp_expend_info" label="对公支出信息" />
      </van-col>
    </van-row>
    <van-row>
      <van-col :span="24">
        <base-textarea v-model="form.remark" label="备注" />
      </van-col>
    </van-row>
    <van-row>
      <van-col :span="24">
        <van-field v-model="form.dept_name" label="部门" placeholder="请选择部门"
                   readonly @click="showDept = true" />
      </van-col>
    </van-row>
    <van-row v-for="(fileType, index) in form.needFileTypeList" :key="index">
      <van-col :span="24">
        <van-field v-model="fileType.path" :label="fileType.name" readonly>
          <template #button>
            <van-uploader v-model="fileType.fileList" :name="index"
                          :max-count="1" accept="*"
                          :before-read="beforeRead" :before-delete="beforeDelete">
              <van-button icon="plus" type="primary">上传</van-button>
            </van-uploader>
          </template>
        </van-field>
      </van-col>
    </van-row>
    <van-row>
      <van-col :span="24">
        <base-button size="large" :loading="loading" :round="true" @click="onSubmit">提 交</base-button>
      </van-col>
    </van-row>
    <van-action-sheet v-model="showApproveItem" title="审批事项">
      <van-tree-select
        :items="approveItems"
        :active-id.sync="activeIdOfApproveItem"
        :main-active-index.sync="activeIndexOfApproveItem"
        @click-item="onItemSelectedOfApproveItem"
      />
    </van-action-sheet>

    <van-popup v-model="showDept" round position="bottom">
      <van-cascader
        v-model="form.dept_id"
        title="请选择部门"
        :options="deptData"
        :field-names="fieldNames"
        @finish="onFinish"
      />
    </van-popup>

    <init :init-states="initStates" @after-init="init" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Init from '@/components/base/init'
import { getApproveItemList } from '@/api/settings/approve-item'
import { getSysDictionariesList } from '@/api/commons'
import { addApproveInfo, modifyApproveInfo, uploadFileOfApproveInfo,
  deleteFileOfApproveInfo } from '@/api/settings/approve-info'
export default {
  name: 'ApproveInfo',
  components: { Init },
  data() {
    return {
      loading: false,
      showDept: false,
      showApproveItem: false,
      disabled: false,
      activeIdOfApproveItem: 1,
      activeIndexOfApproveItem: 0,
      activeIdOfDept: 1,
      activeIndexOfDept: 0,
      approveItems: [],
      approveMap: new Map(),
      deptMap: new Map(),

      formModel: {},
      form: {
        id: null,
        corp: null,
        itemName: '',
        approve_item_id: null,
        selectedApproveItem: null,
        needFileTypeList: [],
        approve_type: null,
        approve_amount: null,
        get_invoice_date: '',
        corp_expend_info: '',
        remark: '',
        dept_name: '',
        dept_id: null,
        files: []
      },
      fieldNames: {
        text: 'label',
        value: 'id',
        children: 'children'
      },
      dictList: [],
      initStates: [{
        key: 'dept/init'
      }]
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'deptData', 'deptMapOfIdsArray'])
  },
  methods: {
    init() {
      this.deptMap.clear()
      this.Utils.setTreeData(this.deptData, row => {
        this.deptMap.set(row.id, row)
      })
      this.queryApproveItemList().then(() => {
        this.querySysDictionariesList().then(() => {
          this.loadForm()
        })
      })
    },
    beforeRead(file, { name }) {
      return new Promise((resolve, reject) => {
        const fileType = this.form.needFileTypeList[name]
        const formData = new FormData()
        formData.append('file', file)
        if (this.form.id) {
          formData.append('main_id', +this.form.id)
          formData.append('file_type', fileType.id)
        }
        uploadFileOfApproveInfo(formData).then(resp => {
          this.success(resp.msg)
          fileType.fileId = resp.obj.id
          fileType.path = file.name
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    beforeDelete(file, { name }) {
      return new Promise((resolve, reject) => {
        const fileType = this.form.needFileTypeList[name]
        if (this.form.id) {
          if (fileType && fileType.fileId > 0) {
            deleteFileOfApproveInfo({
              id: fileType.fileId
            }).then(resp => {
              this.clearFile(fileType)
              this.success(resp.msg)
              resolve()
            }).catch(() => {
              reject()
            })
          } else {
            reject()
          }
        } else {
          this.clearFile(fileType)
          resolve()
        }
      })
    },
    clearFile(fileType) {
      fileType.path = ''
      fileType.fileId = null
      fileType.fileList = []
    },
    onSubmit() {
      if (!this.form.corp) {
        this.error('请选择主体')
        return
      }
      if (!this.form.approve_item_id) {
        this.error('请选择审批事项')
        return
      }
      if (this.form.approve_type === 2 && !this.form.get_invoice_date) {
        this.error('请选择回票日期')
        return
      }
      // approve_item_id为对公付款时，必须填写
      if (this.form.selectedApproveItem.pid === 3 && !this.form.corp_expend_info.trim()) {
        this.error('请填写对公支出信息')
        return
      }

      if (this.form.needFileTypeList.length > 0) {
        const approveAmount = +(this.form.approve_amount || 0)
        const files = []
        for (let i = 0; i < this.form.needFileTypeList.length; i++) {
          const fileType = this.form.needFileTypeList[i]
          if (approveAmount >= +this.form.selectedApproveItem.amount_threshold &&
            !fileType.fileId) {
            this.error(`请上传 第${i + 1}个 ${fileType.name}附件`)
            return
          } else {
            files.push({
              id: fileType.fileId,
              file_type: fileType.id
            })
          }
        }
        this.form.files = files
      }
      this.form.dept_id = +this.form.dept_id
      if (this.form.id) {
        this.confirm(`确定保存审批吗？`).then(() => {
          modifyApproveInfo(this.form).then(resp => {
            this.success(resp.msg)
          })
        })
      } else {
        this.confirm(`确定提交审批吗？`).then(() => {
          addApproveInfo(this.form).then(resp => {
            this.form.id = resp.obj.id
            this.success(resp.msg)
          })
        })
      }
    },
    initNeedFileTypeList() {
      this.form.needFileTypeList = []
      if (this.form.selectedApproveItem && this.form.selectedApproveItem.need_file_type) {
        const fileTypeList = this.form.selectedApproveItem.need_file_type.split(',') || []
        fileTypeList.forEach(fileType => {
          this.form.needFileTypeList.push({
            id: +fileType,
            name: this.dictList.find(dict => dict.id === +fileType).name,
            path: '',
            fileId: null,
            fileList: []
          })
        })
      }
    },
    onFinish({ selectedOptions }) {
      this.showDept = false
      this.form.dept_name = selectedOptions.map(option => option.label).join(' / ')
    },
    onItemSelectedOfApproveItem(data) {
      this.disabled = false
      this.form.selectedApproveItem = data

      if (data.allow_approve_type === 1) { // 无要求
        this.form.approve_type = data.default_approve_type
      } else if (data.allow_approve_type === 2) {
        this.disabled = true
        this.form.approve_type = 1 // 1：凭票付款
      } else if (data.allow_approve_type === 3) {
        this.disabled = true
        this.form.approve_type = 2 // 2：先款后票
      } else {
        this.form.approve_type = null
      }

      this.initNeedFileTypeList()

      if (data.pid > 0) {
        const approveItem = this.approveMap.get(data.pid)
        this.form.approve_item_id = data.id
        this.form.itemName = `${approveItem.name}_${data.name}`
      } else {
        this.form.approve_item_id = null
        this.form.itemName = ''
      }
      this.showApproveItem = false
    },
    querySysDictionariesList() {
      return new Promise((resolve, reject) => {
        getSysDictionariesList().then(resp => {
          this.dictList = resp.rows || []
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    queryApproveItemList() {
      return new Promise((resolve, reject) => {
        getApproveItemList().then(resp => {
          const rows = resp.rows || []
          this.approveMap.clear()
          this.Utils.setTreeData(rows, row => {
            row.text = row.name
            this.approveMap.set(row.id, row)
          })
          this.approveItems = rows
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    resetForm(isModify) {
      this.Utils.resetValue(this.form)
      if (!isModify && this.userInfo.dept_ids) {
        const tmpDeptIdArray = this.userInfo.dept_ids.split(',')
        if (tmpDeptIdArray.length > 0) {
          this.form.dept_id = tmpDeptIdArray[0]
          const deptIdArray = this.deptMapOfIdsArray[this.form.dept_id]
          this.form.dept_name = deptIdArray.map(deptId => this.deptMap.get(deptId).label).join(' / ')
        }
      }
    },
    loadForm() {
      this.loading = true
      const data = localStorage.getItem('approveInfoModel')
      if (data) {
        this.formModel = JSON.parse(data)
        localStorage.removeItem('approveInfoModel')
        if (this.formModel.id > 0) {
          this.resetForm(true)
          // 克隆一份formModel，防止列表对象被修改
          Object.assign(this.form, this._.cloneDeep(this.formModel))
          const approveItem = this.approveMap.get(this.form.approve_item_id)
          this.form.selectedApproveItem = approveItem
          if (approveItem.allow_approve_type === 2 ||
            approveItem.allow_approve_type === 3) {
            this.disabled = true
          }
          if (approveItem.pid > 0) {
            const parentApproveItem = this.approveMap.get(approveItem.pid)
            this.form.itemName = `${parentApproveItem.name}_${approveItem.name}`
          }

          const deptIdArray = this.deptMapOfIdsArray[this.form.dept_id]
          this.form.dept_name = deptIdArray.map(deptId => this.deptMap.get(deptId).label).join(' / ')

          if (approveItem && approveItem.need_file_type) {
            const fileTypeList = approveItem.need_file_type.split(',') || []
            fileTypeList.forEach((fileType, ind) => {
              const file = this.form.files ? this.form.files[ind] : null
              this.form.needFileTypeList.push({
                id: +fileType,
                name: this.dictList.find(dict => dict.id === +fileType).name,
                path: file ? file.file_url.substring(file.file_url.lastIndexOf('/') + 1) : '',
                fileId: file ? file.id : null,
                fileList: file ? [{}] : []
              })
            })
          }
        } else {
          this.resetForm()
        }
        this.loading = false
      } else {
        this.resetForm()
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/approve-info/apply.vue